export default __webpack_public_path__ + "static/media/src_img_12.3560c8e2.png";